<div
  [class]="
    selected
      ? 'border-2 tw-border-green-500 tw-bg-green-100 dark:tw-bg-green-950'
      : ''
  "
  (click)="onEmitSelectedDay(model)"
  class="plan tw-flex tw-items-center tw-justify-center tw-relative tw-rounded-2xl tw-h-full tw-cursor-pointer"
  [ngClass]="{
    'tw-bg-primary-100 dark:tw-bg-primary-800': model?.solarDate == todayDate,
    'tw-bg-gray-50 dark:tw-bg-dark-600': model?.solarDate != todayDate
  }"
>
  <div class="tw-flex tw-flex-col tw-items-center tw-mt-4">
    <div
      class="tw-w-full tw-flex tw-flex-col tw-items-center tw-justify-center"
    >
      <h1
        [ngClass]="
          model?.isHoliday || model?.daysOfWeek == 6
            ? 'text-danger'
            : 'tw-text-gray-700 dark:tw-text-gray-300'
        "
        class="tw-font-semibold tw-text-[18px] tw-mx-4"
      >
        {{ model?.day }}
      </h1>
    </div>
    <div
      *ngIf="totalEventsCategories.length != 0; else empty"
      class="tw-h-4 tw-whitespace-nowrap"
    >
      @if(showEventCircle){
      <i
        *ngFor="let item of totalEventsCategories"
        [calendarEventDisplayer]="item"
        [calendarEventIcon]="item"
      ></i>
      } @else{
      <i *ngFor="let item of totalEventsCategories"></i>
      }
    </div>
    <ng-template #empty>
      <div class="tw-h-4"></div>
    </ng-template>
  </div>
</div>
